import actions from './actions';

const {
  GET_BITAQATY_BALANCE_BEGIN,
  GET_BITAQATY_BALANCE_SUCCESS,
  GET_BITAQATY_BALANCE_ERR,
  GET_QWIK_BALANCE_BEGIN,
  GET_QWIK_BALANCE_SUCCESS,
  GET_QWIK_BALANCE_ERR,
  GET_DALEEL_STORE_BALANCE_BEGIN,
  GET_DALEEL_STORE_BALANCE_SUCCESS,
  GET_DALEEL_STORE_BALANCE_ERR,
  GET_PAYNET_BALANCE_BEGIN,
  GET_PAYNET_BALANCE_SUCCESS,
  GET_PAYNET_BALANCE_ERR,
} = actions;

const initState = {
  loadingGetBitaqatyBalance: false,
  errorGetBitaqatyBalance: '',
  balance: 0,
};

const refillBalanceReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_BITAQATY_BALANCE_BEGIN:
      return {
        ...state,
        balance: 0,
        loadingGetBitaqatyBalance: true,
        errorGetBitaqatyBalance: null,
      };
    case GET_BITAQATY_BALANCE_SUCCESS:
      return {
        ...state,
        balance: data.balance,
        loadingGetBitaqatyBalance: false,
        errorGetBitaqatyBalance: null,
      };
    case GET_BITAQATY_BALANCE_ERR:
      return {
        ...state,
        errorGetBitaqatyBalance: err,
        loadingGetBitaqatyBalance: false,
      };
    case GET_QWIK_BALANCE_BEGIN:
      return {
        ...state,
        balance: 0,
        loadingGetBitaqatyBalance: true,
        errorGetBitaqatyBalance: null,
      };
    case GET_QWIK_BALANCE_SUCCESS:
      return {
        ...state,
        balance: data.balance,
        loadingGetBitaqatyBalance: false,
        errorGetBitaqatyBalance: null,
      };
    case GET_QWIK_BALANCE_ERR:
      return {
        ...state,
        errorGetBitaqatyBalance: err,
        loadingGetBitaqatyBalance: false,
      };
    case GET_DALEEL_STORE_BALANCE_BEGIN:
      return {
        ...state,
        balance: 0,
        loadingGetBitaqatyBalance: true,
        errorGetBitaqatyBalance: null,
      };
    case GET_DALEEL_STORE_BALANCE_SUCCESS:
      return {
        ...state,
        balance: data.balance,
        loadingGetBitaqatyBalance: false,
        errorGetBitaqatyBalance: null,
      };
    case GET_DALEEL_STORE_BALANCE_ERR:
      return {
        ...state,
        errorGetBitaqatyBalance: err,
        loadingGetBitaqatyBalance: false,
      };
    case GET_PAYNET_BALANCE_BEGIN:
      return {
        ...state,
        balance: 0,
        loadingGetBitaqatyBalance: true,
        errorGetBitaqatyBalance: null,
      };
    case GET_PAYNET_BALANCE_SUCCESS:
      return {
        ...state,
        balance: data,
        loadingGetBitaqatyBalance: false,
        errorGetBitaqatyBalance: null,
      };
    case GET_PAYNET_BALANCE_ERR:
      return {
        ...state,
        errorGetBitaqatyBalance: err,
        loadingGetBitaqatyBalance: false,
      };
    default:
      return state;
  }
};

export { refillBalanceReducer };
